import $ from 'jquery/src/jquery';

export default () => {
    const nodeSelectors = {
        container: '[js-site-nav="container"]',
    }

    function init() {
        if (!document.querySelector(nodeSelectors.container)) {
            return
        }

        $(nodeSelectors.container + ' .menu-item-has-children').on('click', function (e) {
            let subMenu = $(this).find(' > .sub-menu')

            // If user is on tablet then hover will not work so this will prevent page redirect if menu item has sub-menu
            // It will open sub menu on first click/touch and on the second it will redirect to another page
            if( subMenu.css('visibility') === 'hidden' ) {
                e.preventDefault()
            }
        })
    }

    return Object.freeze({
        init,
    })
}